import dayjs from 'dayjs';
import { keepOneAndWanOrLine } from '@/utils/utils';

interface TrendDataItem {
  date: string;
  flow: number | null; // 电
  air: number | null; // 压缩空气
  pressure: number | null; // 天然气
}

const X_FORMAT_MAP: Record<string, string> = {
  month: 'MM-DD',
  year: 'YYYY-MM',
};

export const getEnergyTrendChartOption = (data: TrendDataItem[], timeFormat: string = 'MM-DD') => {
  const colors = ['#52E7FF', '#2D8DFF', '#FFCB47'];
  const xFormat = X_FORMAT_MAP[timeFormat] || 'MM-DD';

  return {
    backgroundColor: 'transparent',
    color: colors,
    legend: [
      {
        top: 0,
        right: 170,
        icon: 'rect',
        itemWidth: 12,
        itemHeight: 12,
        itemGap: 20,
        data: ['电'],
      },
      {
        top: 0,
        right: 10,
        icon: 'rect',
        itemWidth: 16,
        itemHeight: 4,
        itemGap: 20,
        data: ['压缩空气', '天然气'],
      },
    ],
    tooltip: {
      trigger: 'axis',
      formatter: (items: any) => {
        const { axisValue } = items[0];
        let str = `<div style="padding: 4px;">${axisValue}</div>`;
        items.forEach((item: any) => {
          const shortName =
            (item.seriesName ?? '').length > 12 ? item.seriesName?.slice(0, 12) + '...' : item.seriesName;
          const unit = item.seriesName === '电' ? 'kWh' : 'm³';
          str += `<div style="margin-top:8px;width:220px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${
            item.marker
          }</span>${shortName}</div><div>${keepOneAndWanOrLine(item.value)} ${unit}</div></div></div>`;
        });
        return str;
      },
    },
    xAxis: {
      type: 'category',
      data: data.map(item => item.date),
    },
    yAxis: [
      { type: 'value', name: 'kWh', splitNumber: 5, axisTick: { alignTicks: true } },
      { type: 'value', name: 'm³', splitNumber: 5, axisTick: { alignTicks: true } },
    ],
    series: [
      {
        name: '电',
        type: 'bar',
        barMaxWidth: 20,
        data: data.map(item => item.flow),
        itemStyle: { color: colors[0] },
      },
      {
        name: '压缩空气',
        type: 'line',
        smooth: true,
        symbol: 'none',
        yAxisIndex: 1,
        data: data.map(item => item.air),
        itemStyle: { color: colors[1] },
      },
      {
        name: '天然气',
        type: 'line',
        smooth: true,
        symbol: 'none',
        yAxisIndex: 1,
        data: data.map(item => item.pressure),
        itemStyle: { color: colors[2] },
      },
    ],
  };
};
